import script from "./JoinToTeamForm.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinToTeamForm.vue?vue&type=script&setup=true&lang=js"

import "./JoinToTeamForm.vue?vue&type=style&index=0&id=3c908f61&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c908f61"]])

export default __exports__